/**
 * Auto-atribuição da conversa no primeiro envio + nome do atendente.
 */
import { supabase } from '../../../lib/supabase';
import { generateJidVariants } from '../../../utils/phoneUtils';
import { notifyPartykitLocalMessage } from '../utils/partykitSocket';

/** Nome exibido do atendente no auto-assign / mensagem de sistema. */
export function resolveChatAgentDisplayName(
    profileName: string | undefined,
    meta: { name?: string; full_name?: string } | undefined,
): string {
    return profileName || meta?.name || meta?.full_name || 'Atendente';
}

/** Auto-atribui conversa ao primeiro envio e insere mensagem de sistema. */
export async function autoAssignConversationOnSend(params: {
    conversationId: string;
    organizationId: string;
    displayName: string;
    messagingConnectionId: string | null;
    assignConversation: (conversationId: string) => Promise<boolean>;
    refreshMessages: () => void;
}): Promise<void> {
    const {
        conversationId,
        organizationId,
        displayName,
        messagingConnectionId,
        assignConversation,
        refreshMessages,
    } = params;

    // Sem connection do envio → não atribui (evita pegar a conversa da outra linha WA/IG).
    if (!messagingConnectionId) return;

    let query = supabase
        .from('chat_conversations')
        .select('id, assigned_to')
        .in('remote_jid', generateJidVariants(conversationId))
        .eq('organization_id', organizationId)
        .eq('connection_id', messagingConnectionId);

    const { data: convDb, error: fetchError } = await query
        .order('last_message_time', { ascending: false })
        .limit(1)
        .maybeSingle();

    if (fetchError) {
        console.error('[AutoAssign] Erro ao buscar conversa:', fetchError);
        return;
    }

    if (!convDb || convDb.assigned_to) return;

    const success = await assignConversation(conversationId);
    if (!success) return;

    const timeString = new Date().toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
    });

    const systemMessageId = `sys-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    const systemContent = `${displayName} assumiu a conversa às ${timeString}`;
    const { error: insertError } = await supabase.from('chat_messages').insert({
        message_id: systemMessageId,
        conversation_id: convDb.id,
        organization_id: organizationId,
        message_type: 'system',
        content: systemContent,
        sender: 'system',
        timestamp: new Date().toISOString(),
        status: 'sent',
    });

    if (insertError) {
        console.error('[AutoAssign] Falha ao inserir msg de sistema:', insertError);
    } else {
        void notifyPartykitLocalMessage({
            conversationId: convDb.id,
            organizationId,
            messageId: systemMessageId,
            fromMe: true,
            content: systemContent,
            messageType: 'system',
        });
        refreshMessages();
    }
}
